// import api from '../../api/index.js';
import { useState } from 'react';
import s from './Products.module.scss';
import api from '../../api/index.js';
import { formatDateMsk } from '../../utils/date.js';
// import arrowIcon from '../../assets/icons/arrow.js';
// import Loader from '../../components/Loader/Loader.jsx';

const SubProductItem = ({ product, changeStatus, activeProduct, toMaster, onFlagUpdate }) => {
  const [isUpdatingFlag, setIsUpdatingFlag] = useState(false);

  const getPercentClass = (percent) => {
    if (percent < 50) return s.red;
    else if (percent < 75) return s.yellow;
    else return s.green;
  };

  const handleFlagChange = async (e) => {
    e.stopPropagation();
    const newValue = e.target.checked;
    setIsUpdatingFlag(true);

    try {
      const result = await api.products.setDoNotMasterFlag(
        product._id || product.item_products_id,
        newValue
      );

      if (!result.error) {
        // Обновляем локальное состояние через callback
        if (onFlagUpdate) {
          onFlagUpdate(product._id || product.item_products_id, newValue);
        }
      } else {
        console.error('Ошибка при обновлении флага:', result.error);
        // Возвращаем чекбокс в исходное состояние при ошибке
        e.target.checked = !newValue;
      }
    } catch (error) {
      console.error('Ошибка при обновлении флага:', error);
      e.target.checked = !newValue;
    } finally {
      setIsUpdatingFlag(false);
    }
  };

  return (
    <li className={s.catWrap}>
      <div
        className={
          s.cat +
          ' ' +
          (+product.status === 1 ? s.active : '') +
          ' ' +
          s.withBtnMaster
        }
        // onClick={() => activeProduct._id && changeStatus(product)}
      >
        <div className={s.catNameWrap}>
          {product.percent && (
            <p
              className={s.catPercent + ' ' + getPercentClass(product.percent)}
            >
              {product.percent}%
            </p>
          )}
          <h3 className={s.catName}>{product.title}</h3>
          {activeProduct._id && (
            <button
              onClick={() => changeStatus(product)}
              className={
                'btn small ' +
                (+product.status === 1 ? 'red ' : 'dark ') +
                s.btnMaster
              }
            >
              {+product.status === 1 ? 'Удалить связь' : 'Cоотнести'}
            </button>
          )}
          {!activeProduct._id && (
            <button
              onClick={() => toMaster(product)}
              className={'btn dark small ' + s.btnMaster}
            >
              Сделать мастером
            </button>
          )}
        </div>
        <ul className={s.catStickers}>
          {product.api_name && (
            <li className={s.sticker + ' ' + s.yellow}>
              api: {product.api_name}
            </li>
          )}
          {(product._id || product.item_products_id) && (
            <li className={s.sticker + ' ' + s.violet}>
              id: {product._id || product.item_products_id}
            </li>
          )}
          <li className={s.sticker + ' ' + (product.is_item_updated ? s.green : s.red)}>
            {product.is_item_updated ? 'Есть в API' : 'Нет в API'}
          </li>
          {product.updated_at && (
            <li className={s.sticker + ' ' + s.pink}>
              🕐 {formatDateMsk(product.updated_at)}
            </li>
          )}
          <li
            className={
              s.sticker +
              ' ' +
              s.doNotMasterFlag +
              ' ' +
              (product.do_not_set_as_master ? s.active : s.inactive) +
              ' ' +
              (isUpdatingFlag ? s.loading : '')
            }
          >
            <label className={s.checkboxLabel}>
              <input
                type="checkbox"
                checked={product.do_not_set_as_master || false}
                onChange={handleFlagChange}
                disabled={isUpdatingFlag}
                className={s.checkbox}
              />
              <span className={s.checkboxText}>Не мастер</span>
              {isUpdatingFlag && <span className={s.loader}></span>}
            </label>
          </li>
        </ul>
      </div>
    </li>
  );
};

export default SubProductItem;
